import React from "react";
import TroubleInfo from "../components/cctv/trouble/TroubleInfo";
import MachineInfo from "../components/cctv/trouble/MachineInfo";
import WorkInfo from "../components/cctv/trouble/WorkInfo";
import Trouble from "../components/cctv/trouble/Trouble";
import EmptyData from "../components/cctv/trouble/EmptyData";
import {DateUtils} from "../module/DateUtils";
import {AppConfig} from "../AppConfig";
import './CCTV.css';
import LoadingData from "../components/cctv/trouble/LoadingData";
import axios from "axios";

class CCTV extends React.Component {

    dateUtils = new DateUtils();

    constructor(props) {
        super(props);
        this.props = props;
        this.state = {serviceState: -1};
        this.getData();
        setInterval(this.getData.bind(this), AppConfig.cctv.refreshMs);
    }

    getData() {
        // alert("s");
        // console.log(AppConfig.server);
        axios.get(AppConfig.server + AppConfig.service.cctv.activeCall)
            .then((res) => {
                const data = res.data;
                if (data.success) {
                    this.data = data["data"];
                    this.setState({
                        serviceState: 1
                    });
                } else
                    this.setState({
                        serviceState: 2
                    });
            })
            .catch(e => {
                this.setState({
                    serviceState: 2
                });
            })
    }

    render() {
        if (this.state.serviceState === 1) {
            return (
                <div style={{
                    width: 100 + "%",
                    height: 100 + "%",
                    position: "fixed",
                    overflow: "auto",
                    backgroundColor: "black"
                }}>
                    <div>
                        {this.renderTrouble()}
                    </div>
                </div>
            );
        } else if (this.state.serviceState === 2)
            return (
                <div style={{
                    width: 100 + "%",
                    height: 100 + "%",
                    position: "absolute",
                    backgroundColor: "black",
                    padding: "5px"
                }}>
                    <EmptyData/>
                </div>
            );

        else
            return (
                <div style={{
                    width: 100 + "%",
                    height: 100 + "%",
                    position: "absolute",
                    backgroundColor: "black",
                    padding: "5px"
                }}>
                    <LoadingData/>
                </div>
            );
    }

    renderTrouble() {

        const data = this.data;

        if (data.length > 0) {
            const troublesComp = [];
            for (let i = 0; i < data.length; i++) {
                const currentData = data[i];

                const troubleInfo = <TroubleInfo
                    name={currentData["callType"]["name"]}
                    code={currentData["callType"]["code"]}
                    roleName={currentData["unit"]["unitGroup"]["groupName"]}
                    date={this.dateUtils.getStrDate(currentData["createdTime"])}/>;

                const machineInfo = <MachineInfo
                    name={currentData["unit"]["name"]}
                    code={currentData["unit"]["unitCode"]}/>;

                let workInfo;
                //let troubleDesc;

                let bgColor;
                if(currentData["workHistories"].length>0) {
                    const workData = currentData["workHistories"][0];
                    workInfo = <WorkInfo
                        work={workData["work"]["name"]}
                        user={workData["user"]["name"] + " " + workData["user"]["surname"]}
                        date={this.dateUtils.getStrDate(workData["startTime"])}/>;
                    bgColor = workData["work"]["buttonAttrs"]["color"];
                }
                else {
                    workInfo = <WorkInfo
                        work={"İşlem Bekliyor"}/>;
                    bgColor = "#FFFFFF"
                }


                /*let desc = "bulunamadı";
                if(currentData["lastDesc"]!=null)
                    desc = currentData["lastDesc"];
                troubleDesc = <TroubleDesc
                    data={desc}/>;*/


                const troubleData = <Trouble troubleInfo={troubleInfo}
                                             machineInfo={machineInfo}
                                             workInfo={workInfo}
                    //troubleDesc={troubleDesc}
                                             bg={bgColor}/>;
                troublesComp.push(troubleData);
            }

            //const app = <App>{troublesComp}</App>;

            return troublesComp;
        } else {
            return <EmptyData/>;
        }
    }


}

export default CCTV